import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { AiFillMediumSquare } from 'react-icons/ai';
import { TbWorld } from 'react-icons/tb';

export const skillsData = [
  {
    id: 1,
    title: 'Reactjs',
    level: 'Advanced',
  },
  {
    id: 2,
    title: 'Redux State Management',
    level: 'Advanced',
  },
  {
    id: 3,
    title: 'Angularjs',
    level: 'Intermediate',
  },
  {
    id: 4,
    title: 'HTML,CSS',
    level: 'Advanced',
  },
  {
    id: 5,
    title: 'Nextjs',
    level: 'Advanced',
  },
  {
    id: 6,
    title: 'Nodejs',
    level: 'Intermediate',
  },
  {
    id: 7,
    title: 'Javascript',
    level: 'Advanced',
  },
   {
    id: 8,
    title: 'Typescript',
    level: 'Advanced',
  },
  {
    id: 9,
    title: 'MongoDB',
    level: 'Intermediate',
  },
  {
    id: 10,
    title: 'GraphQL',
    level: 'Intermediate',
  },
  {
    id: 11,
    title: 'Apollo Client',
    level: 'Intermediate',
  },
  {
    id: 12,
    title: 'Tailwind CSS',
    level: 'Advanced',
  },
  {
    id: 13,
    title: 'Material UI',
    level: 'Advanced',
  },
];

export const experienceOneCardData = {
  title: 'Software Engineer @Celebal Technologies',
  location: 'Jaipur, India',
  description: `
  Working as a Frontend Developer at Celebal Technologies, I’ve been responsible for building scalable, performant, and accessible user interfaces using modern JavaScript frameworks. 
  From enterprise dashboards to AI-integrated solutions, I deliver production-grade applications with a focus on responsiveness, maintainability, and user experience. 
  I actively collaborate with cross-functional teams and follow clean code practices to ensure consistent and high-quality delivery.
  `,
  list: [
    {
      id: 1,
      text: 'Led frontend development for Greenprint AI projects using Next.js, ReactJS, React Query, Zustand, Material UI, and Context API to deliver robust and scalable applications.',
    },
    {
      id: 2,
      text: 'Developed dynamic and data-driven dashboards featuring advanced charting and visualization to support client decision-making in AI-based platforms.',
    },
    {
      id: 3,
      text: 'Worked on a legacy AngularJS-based enterprise project, maintaining and extending frontend features while ensuring compatibility with modern standards.',
    },
    {
      id: 4,
      text: 'Built and optimized Microsoft Teams-integrated UIs using Microsoft’s ReactJS libraries for Tab and Chatbot TaskModules, enhancing user interaction flows.',
    },
    {
      id: 5,
      text: 'Implemented efficient global state management using Redux Toolkit and Zustand, improving code organization and reducing bugs in complex workflows.',
    },
    {
      id: 6,
      text: 'Ensured mobile responsiveness and accessibility across web applications by adhering to best practices in semantic HTML, Tailwind CSS, and Material UI.',
    },
    {
      id: 7,
      text: 'Collaborated closely with UI/UX teams and backend engineers in Agile environments to ship high-quality releases under tight deadlines.',
    },
  ],
  techStack: [
    { id: 1, label: 'JavaScript' },
    { id: 2, label: 'TypeScript' },
    { id: 3, label: 'ReactJS' },
    { id: 4, label: 'Next.js' },
    { id: 5, label: 'React Query' },
    { id: 6, label: 'Zustand' },
    { id: 7, label: 'Redux / Redux Toolkit' },
    { id: 8, label: 'Material UI' },
    { id: 9, label: 'Tailwind CSS' },
    { id: 10, label: 'AngularJS' },
    { id: 11, label: 'Node.js' },
    { id: 12, label: 'Apollo Client' },
    { id: 13, label: 'NPM / Yarn' },
    { id: 14, label: 'Azure' },
    { id: 15, label: 'Git / GitHub' },
  ],
};


export const experienceTwoCardData = {
  title: 'Frontend Developer Intern @Celebal Technologies',
  location: 'Jaipur, India',
  description: `
  As a Frontend Intern at Celebal Technologies, I gained hands-on experience in modern web development by building responsive and accessible UIs using ReactJS and core web technologies. 
  I contributed to real-time projects, collaborated with senior developers, and learned to integrate third-party libraries while adhering to design standards and performance best practices.
  `,
  list: [
    {
      id: 1,
      text: 'Built responsive web interfaces using HTML, CSS, JavaScript, and ReactJS for real-world business applications.',
    },
    {
      id: 2,
      text: 'Integrated Microsoft Fluent UI and Material UI components to enhance UI consistency and improve usability across enterprise-grade applications.',
    },
    {
      id: 3,
      text: 'Collaborated on the development of Microsoft Teams Tab interface, focusing on layout, responsiveness, and cross-platform compatibility.',
    },
    {
      id: 4,
      text: 'Practiced clean coding principles and version control with Git while working in Agile sprints alongside experienced engineers.',
    },
  ],
  techStack: [
    { id: 1, label: 'HTML' },
    { id: 2, label: 'CSS' },
    { id: 3, label: 'JavaScript' },
    { id: 4, label: 'ReactJS' },
    { id: 5, label: 'Redux' },
    { id: 6, label: 'Material UI' },
    { id: 7, label: 'Fluent UI' },
    { id: 8, label: 'Git' },
  ],
};


export const projectOneCardData = {
  techStack: [
    { id: 1, label: 'ReactJS' },
    { id: 2, label: 'Context API' },
    { id: 3, label: 'Microsoft Bot Framework' },
    { id: 4, label: 'Javascript' },
    { id: 5, label: 'HTML/SCSS' },
    { id: 6, label: 'Azure Devops' },

  ],
  title: 'Discover ASR Cubby Chatbot',
  subTitle:
    'Developed a chatbot solution to enhance user interaction, feedback collection, and data analytics for continuous performance improvement.',
  description: `
  Played a key role in designing and developing the Discover ASR Cubby chatbot interface using ReactJS. 
  Focused on enhancing performance, usability, and analytics by integrating UTM tracking, feedback systems, and Azure Table Storage for user interaction data.
  Ensured maintainable, scalable, and high-quality code while following modern frontend practices and collaborating with cross-functional teams.
  `,
  featureTitle: 'Project Tasks and Accomplishments -',
 featureLists: [
  {
    id: 1,
    text: 'Resolved key frontend bugs to improve chatbot stability, resulting in a smoother user experience across multiple devices and browsers.',
  },
  {
    id: 2,
    text: 'Integrated UTM tag appending functionality into dynamic backend links, enabling enhanced user tracking and actionable campaign analytics.',
  },
  {
    id: 3,
    text: 'Designed and implemented a feedback collection feature tied to conversation IDs, enabling real-time monitoring and iterative performance tuning.',
  },
  {
    id: 4,
    text: 'Stored and managed user interaction logs in Azure Table Storage for scalable data handling and advanced analytical reporting.',
  },
  {
    id: 5,
    text: 'Collaborated cross-functionally with backend and QA teams to ensure pixel-perfect UI integration and seamless feature delivery in agile sprints.',
  },
],
  exploreBtn: [
      {
      id: 1,
      name: 'Visit Website',
      icon: <TbWorld />,
      url: '',
    },
    {
      id: 2,
      name: 'Source Code',
      icon: <BsGithub />,
      url: '', // 🔁 Replace with actual repo link
    },
  ],
};


export const projectTwoCardData = {
  techStack: [
    { id: 1, label: 'ReactJS' },
    { id: 2, label: 'Fluent UI' },
    { id: 3, label: 'Redux Js' },
    { id: 4, label: 'REST API' },
    { id: 5, label: 'Azure Devops' },

  ],
  title: 'Ejazate Chatbot',
  subTitle:
    'Built an intelligent leave management chatbot interface with employee/manager calendars, reusable forms, and seamless backend integration.',
  description: `
  Contributed to the development of Ejazate Chatbot — a comprehensive leave management tool that simplifies leave tracking and approvals for both employees and managers. 
  The system includes interactive calendars, reusable forms, and advanced table functionalities like filtering, pagination, and attachments to enhance user experience and performance.
  `,
  featureTitle: 'Some of the Important features -',
  featureLists: [
    {
      id: 1,
      text: 'Developed dynamic employee and manager leave calendars with visual highlights for pending, approved, rejected, and casual leaves.',
    },
    {
      id: 2,
      text: 'Created reusable form components for creating and updating leave requests, stored in responsive tables with inline view/edit actions.',
    },
    {
      id: 3,
      text: 'Built manager-specific functionalities including leave approvals, viewing team schedules, and managing allocations via secure role-based flows.',
    },
    {
      id: 4,
      text: 'Integrated features like file download/upload, table filtering, and pagination to improve accessibility and efficiency for end-users.',
    },
    {
      id: 5,
      text: 'Collaborated with backend developers to ensure smooth data flow and conducted extensive UI testing to deliver a stable, production-ready chatbot.',
    },
  ],
  exploreBtn: [
      {
      id: 1,
      name: 'Visit Website',
      icon: <TbWorld />,
      url: '',
    },
    {
      id: 2,
      name: 'Source Code',
      icon: <BsGithub />,
      url: '', // 🔁 Replace with real link if different
    },
  ],
};


export const projectThreeCardData = {
  techStack: [
    { id: 1, label: 'ReactJS' },
    { id: 2, label: 'Next.js 14' },
    { id: 3, label: 'TypeScript' },
    { id: 4, label: 'Material UI' },
    { id: 5, label: 'React Query' },
    { id: 6, label: 'Zustand' },
    { id: 7, label: 'Azure DevOps' },
  ],
  title: 'Greenprint AI',
  subTitle:
    'Developed a sustainability-focused platform with advanced role-based features and Figma-accurate UI using modern React tooling.',
  description: `
  Contributed to the development of Greenprint AI, a platform built with Next.js 14 and Material UI, designed to manage ESG certifications and sustainability metrics. 
  Worked on state management, API integration, and reusable UI components while ensuring pixel-perfect implementation from Figma designs and improving overall frontend architecture.
  `,
  featureTitle: 'Some of the Important features -',
  featureLists: [
    {
      id: 1,
      text: 'Implemented user roles, permission logic, and profile/invite flows using Zustand and React Query within a Next.js 14 architecture.',
    },
    {
      id: 2,
      text: 'Created reusable UI components for ESG certifications, data listings, and metric input forms with high fidelity to Figma specifications.',
    },
    {
      id: 3,
      text: 'Refactored and redesigned 70% of Material UI-based components to align with design system and resolve visual inconsistencies.',
    },
    {
      id: 4,
      text: 'Enhanced user experience by debugging UI issues and introducing custom-styled Material UI components for improved consistency.',
    },
    {
      id: 5,
      text: 'Collaborated with the team to design scalable state and API layers using Zustand and React Query, ensuring maintainability and performance.',
    },
  ],
  exploreBtn: [
      {
      id: 1,
      name: 'Visit Website',
      icon: <TbWorld />,
      url: '',
    },
    {
      id: 2,
      name: 'Source Code',
      icon: <BsGithub />,
      url: '', // Replace if hosted elsewhere
    },
  ],
};


export const projectFourCardData = {
  techStack: [
    {
      id: 1,
      label: 'Reactjs',
    },
    {
      id: 2,
      label: 'Nodejs',
    },
    {
      id: 3,
      label: 'Express',
    },
    {
      id: 4,
      label: 'MongoDB',
    },
    {
      id: 5,
      label: 'GraphQL',
    },
    {
      id: 6,
      label: 'Apollo Client',
    },
    {
      id: 7,
      label: 'Bootstrap',
    },
  ],
  title: 'Project Manager',
  subTitle:
    'Designed a MERNG application for efficient project management, combining MongoDB, Express, React, Node.js, and GraphQL to streamline project coordination and oversight.',
  description: `
  Engineered a robust Project Management solution using the MERNG stack, 
  enabling seamless client addition and deletion, 
  alongside comprehensive project management capabilities 
  including creation, deletion, and updates. Leveraged GraphQL APIs to efficiently retrieve project details, 
  showcasing proficiency in data manipulation and enhancing project coordination.
  `,
  featureTitle: 'Some of the Important features -',
  featureLists: [
    {
      id: 1,
      text: 'Implemented user-friendly functionality to effortlessly add and remove clients within the project, enhancing organizational efficiency and client management.',
    },
    {
      id: 2,
      text: 'Developed a versatile project management feature allowing seamless addition, retrieval, modification, and removal of projects, optimizing workflow and project lifecycle management.',
    },
    {
      id: 3,
      text: 'Implemented a streamlined feature enabling users to retrieve comprehensive project details, enhancing decision-making and facilitating efficient project assessment.',
    },
  ],
  exploreBtn: [
    {
      id: 1,
      name: 'Visit Website',
      icon: <TbWorld />,
      url: '',
    },
    {
      id: 2,
      name: 'Source Code',
      icon: <BsGithub />,
      url: 'https://github.com/InsideAmber/Project-Management',
    },
  ],
};

export const projectFiveCardData = {
  techStack: [
    {
      id: 1,
      label: 'Reactjs',
    },
    {
      id: 2,
      label: 'Solidity',
    },
    {
      id: 3,
      label: 'Smart Contracts',
    },
    {
      id: 4,
      label: 'thirdweb',
    },
    {
      id: 5,
      label: 'Metamask',
    },
    {
      id: 6,
      label: 'tailwind css',
    },
  ],
  title: 'Crowdfunding Web3.0 Applications',
  subTitle:
    'Web3.0 application to raise the fund for different types of events.',
  description: `
  Crowdfunding application is built by using solidity smart contracts with beautiful UI using tailwind
  css where users can raise the fund in ethereum by creating their global events. 
  `,
  featureTitle: 'Some of the Important features -',
  featureLists: [
    {
      id: 1,
      text: 'Users can create the campaigns to raise fund',
    },
    {
      id: 2,
      text: 'User can donate to the fund using metamask ethereum wallet',
    },
    {
      id: 3,
      text: 'We can also get the details of the fund',
    },
  ],
  exploreBtn: [
    {
      id: 1,
      name: 'Visit Website',
      icon: <TbWorld />,
      url: 'https://insidea-crowdfunding-web3.netlify.app',
    },
    {
      id: 2,
      name: 'Source Code',
      icon: <BsGithub />,
      url: 'https://github.com/InsideAmber/Crowdfunding-Web3.0',
    },
  ],
};

export const contacts = [
  {
    id: 2,
    name: 'Github',
    icon: <BsGithub />,
    url: 'https://github.com/InsideAmber',
  },
  {
    id: 3,
    name: 'Linkedin',
    icon: <BsLinkedin />,
    url: 'https://www.linkedin.com/in/amber-khan-4947051b3/',
  },
  {
    id: 4,
    name: 'Medium',
    icon: <AiFillMediumSquare />,
    url: 'https://medium.com/@lostinthoughtshard',
  },
];
